module.exports = __webpack_public_path__ + "static/media/dashboard-logo.c6145722.png";